var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundWaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1523,
    y: 24.54,
    width: 7.42386,
    height: 11.1358,
    rx: 3.71193,
    fill: "#8B5CF6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.288,
    y: 20.8281,
    width: 7.42386,
    height: 18.5596,
    rx: 3.71193,
    fill: "#8B5CF6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4236,
    y: 24.54,
    width: 7.42386,
    height: 11.1358,
    rx: 3.71193,
    fill: "#8B5CF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundWaveIcon);
export default __webpack_public_path__ + "static/media/sound-wave-icon.a75122fc9b147d0883dfd87d929c5247.svg";
export { ForwardRef as ReactComponent };